export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1613909671501-f9678ffc1d33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxmYXNoaW9uJTIwZWRpdG9yaWFsJTIwbW9kZWwlMjBydW53YXklMjBsdXh1cnl8ZW58MHx8fHwxNzkwNDQ5MTEyfDA&ixlib=rb-4.1.0&q=85";

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1567777301743-3b7ef158aadf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxoYXV0ZSUyMGNvdXR1cmUlMjBkcmVzcyUyMGVkaXRvcmlhbCUyMGhpZ2glMjBmYXNoaW9ufGVufDB8fHx8MTc5MDQ0OTExMXww&ixlib=rb-4.1.0&q=85";

export const FILTERS = [
  { id: "all", label: "All Maisons" },
  { id: "couture", label: "Couture & RTW" },
  { id: "street", label: "Streetwear & Denim" },
  { id: "accessoires", label: "Accessories & Enfant" },
];

export const MAISONS = [
  {
    id: "leapbodies",
    numeral: "I",
    index: "01 / III",
    name: "LEAPBODIES",
    category: "Activewear",
    filter: "street",
    aesthetic: "Mind Sharp, Body Strong — workout-ready hoodies & tees",
    status: "Portfolio Brand",
    path: "/leapbodies",
    image: "/products/regular-black.jpg",
    aspect: "aspect-[3/4]",
    colSpan: "md:col-span-7",
    overview:
      "Activewear built for progress, not perfection — comfortable, workout-ready essentials.",
    fabrics: "Performance cotton blends",
    boutiques: "www.leapbodies.com",
    revenue: "Portfolio Brand",
  },
  {
    id: "maison-pique",
    numeral: "II",
    index: "02 / III",
    name: "MAISON PIQUÉ",
    category: "Children's School Polo",
    filter: "accessoires",
    aesthetic: "Piqué-cotton school polos, cut to last the whole year — school logo stitched free",
    status: "Incubated 2022",
    path: "/maison-pique",
    image: "/products/polo-front.jpg",
    aspect: "aspect-square",
    colSpan: "md:col-span-4",
    overview:
      "School uniform polos done properly — breathable piqué cotton, reinforced collars and embroidered crests made to survive the playground and the wash.",
    fabrics: "Piqué cotton, reinforced ribbed collars",
    boutiques: "Online flagship · School partnerships",
    revenue: "Incubated 2022",
  },
  {
    id: "hyrox-flags",
    private: true,
    numeral: "III",
    index: "03 / III",
    name: "HYROX FLAGS",
    category: "Custom Race Flags",
    filter: "accessoires",
    aesthetic:
      "Finisher flags for Hyrox athletes — one city, one season, one division",
    status: "Launched 2025",
    path: "/hyrox-flags",
    image: "/products/flag-new-york.jpg",
    aspect: "aspect-[3/4]",
    colSpan: "md:col-span-4",
    overview:
      "Weatherproof polyester race flags with brass grommets, made to order per city and season.",
    fabrics: "Weatherproof polyester, brass grommets",
    boutiques: "Made to order",
    revenue: "Launched 2025",
  },
];
